export default "__VITE_ASSET__D1Ad6ar___"